// Cache em memória (por sessão do SPA). Reinicia ao dar F5.
// Use para evitar refetch ao navegar.

const store = new Map();

/**
 * @param {string} key
 * @param {{ ttlMs?: number }} options
 */
export function cacheGet(key, options = {}) {
  const { ttlMs } = options;
  const entry = store.get(key);
  if (!entry) return null;

  if (typeof ttlMs === 'number' && ttlMs >= 0) {
    const age = Date.now() - entry.at;
    if (age > ttlMs) {
      store.delete(key);
      return null;
    }
  }

  return entry.value;
}

/**
 * @param {string} key
 * @param {any} value
 */
export function cacheSet(key, value) {
  store.set(key, { value, at: Date.now() });
}

/**
 * @param {string} key
 */
export function cacheDel(key) {
  store.delete(key);
}

/**
 * Limpa todos os itens ou apenas os que começam com prefixo.
 * @param {string=} prefix
 */
export function cacheClear(prefix) {
  if (!prefix) {
    store.clear();
    return;
  }
  for (const key of store.keys()) {
    if (String(key).startsWith(prefix)) store.delete(key);
  }
}

/**
 * Helper: retorna cache ou executa fetcher e guarda.
 * @param {string} key
 * @param {() => Promise<any>} fetcher
 * @param {{ ttlMs?: number, forceRefresh?: boolean }} options
 */
export async function cachedFetch(key, fetcher, options = {}) {
  const { ttlMs, forceRefresh = false } = options;
  if (!forceRefresh) {
    const cached = cacheGet(key, { ttlMs });
    if (cached !== null) return cached;
  }
  const value = await fetcher();
  cacheSet(key, value);
  return value;
}
